export const style = {
  th: {
    borderBottom: `2px solid #666`
  },
  td: {
    borderTop: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Settings/Main/style/ColorBlind/table.js